import BaseService from "./BaseService";
// import { mockRequest, makeCustomerWithID /* , makeInstallationWithID*/ } from "./MockService";
import BusinessEvent from "../core/models/BusinessEvent";
import Paginate from "../core/models/Paginate";
import { IEnumerable } from "../core/models/ModelHelpers";
import IFilter from "../core/contracts/IFilter";
import { isArrayValid } from "../helpers/utility";
import EventStepWithId from "../core/models/EventStepWithId";

export default class BusinessEventService extends BaseService {
  async fetchById(businessEvent_id: number): Promise<BusinessEvent> {
    try {
      const businessEvent: BusinessEvent = await new BaseService().get<BusinessEvent>(
        `/BusinessEvent/?id=${businessEvent_id}`
      );
      return businessEvent;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("BusinessEventService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchBusinessEvents(filterObject: IFilter): Promise<Paginate<BusinessEvent>> {
    try {
      const hasCustomer = filterObject.data.client ? `&Customer=${filterObject.data.client}` : "";
      const hasStatus = filterObject.data.status ? `&Status=${filterObject.data.status}` : "";
      const directoryFilter = filterObject?.data?.directory
        ? `&Directory=${filterObject?.data?.directory}`
        : "";

        const regionFilter = filterObject?.data?.region
        ? `&Region=${filterObject?.data?.region}`
        : "";

      const APIResponse = await new BaseService().getPaginated<BusinessEvent>(
        `/BusinessEvent/ListarEventosFiltrados?PageNumber=${filterObject.pageNumber}` +
          `&PageSize=${filterObject.pageSize}&OrderByDtAscending=${filterObject.orderByAscending}&Id=${filterObject.data.id}` +
          `&EventType=${filterObject.data.eventType}` +
          hasCustomer +
          hasStatus +
          `&IsOpen=${filterObject.data.isOpen}` +
          directoryFilter + regionFilter
      );

      return APIResponse;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("BusinessEventService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async approveCharge(params: EventStepWithId): Promise<boolean> {
    try {
      const requestObj = params;
      return new BaseService().post("/BusinessEvent/aprovarCobranca", requestObj);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationLevelService -> put -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
